import React, { useEffect, useState } from "react";
import Appointments from "./tab1";
import Consulthist from "./tab2";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Select, { components } from "react-select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { formatDate } from "../../reusables/functions";
import axios from "axios";
import Spinner from "../LoadingSpinner/loadingSpinner";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import api from "../../api";
import Swal from "sweetalert2";

const Tab_content = ({ activeTab, setActiveTab }) => {
  const [languageData, setLanguageData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [recalledBy, setRecalledBy] = useState("");
  const [selectedExpert, setSelectedExpert] = useState(null);
  const [expertsLoading, setExpertsLoading] = useState(false);
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [expertOptions, setExpertOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [body, setBody] = useState({
    expert: null,
    date: null,
    recall_type: null,
    recall_value: null,
  });
  const navigate = useNavigate();
  const [dataAppoint, setDataAppoint] = useState({
    total: 0,
    data: [],
  });
  const [appointmentForm, setAppointmentForm] = useState({
    expert_id: null,
    day: "",
    hour: "",
    recall_type: "",
    recall_element: "",
  });
  const handleChangeValue = (field, value) => {
    setAppointmentForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleRecallTypeChange = (type) => {
    setRecalledBy(type);
    setAppointmentForm((prev) => ({
      ...prev,
      recall_type: type === "Phone" ? "call" : type === "SMS" ? "sms" : "email",
      recall_element: "",
    }));
  };

  const fetchExpertsData = async () => {
    try {
      setExpertsLoading(true);
      const response = await api.get(`/content/experts/list`);
      const experts = response?.data?.data ?? [];
      const options = experts.map((expert) => ({
        value: expert.id,
        label: expert.nickname,
        image: expert.image,
      }));
      setExpertOptions(options);
    } catch (error) {
      console.error(error);
      setExpertOptions([]);
    } finally {
      setExpertsLoading(false);
    }
  };
  const LoadingSpinner = () => (
    <div className="text-center p-10">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        className="spinner-svg"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M11.5625,1.87499996 C11.5625,2.73792965 10.8629297,3.43749997 10,3.43749997 C9.13707031,3.43749997 8.43749999,2.73792965 8.43749999,1.87499996 C8.43749999,1.01207027 9.13707031,0.312499952 10,0.312499952 C10.8629297,0.312499952 11.5625,1.01207027 11.5625,1.87499996 Z"
        />
      </svg>
    </div>
  );
  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div ref={innerRef} {...innerProps} className="custom-option mb-2">
        {data.image && (
          <img className="expert_img" src={data.image} alt={data.nickname} />
        )}
        <span>{data.label}</span>
      </div>
    );
  };

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/consultations/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  const handleModalClose = () => {
    setShowModal(false);
    setBody({
      expert: null,
      date: null,
      recall_type: null,
      recall_value: null,
    });
  };
  const handleModalOpen = () => {
    setShowModal(true);
    fetchExpertsData();
  };
  const getCountryFromBrowser = () => {
    const lang = navigator.language || navigator.languages[0];
    return lang?.split("-")[1]?.toLowerCase() || "us";
  };
  const [defaultCountry, setDefaultCountry] = useState("us");

  useEffect(() => {
    setDefaultCountry(getCountryFromBrowser());
  }, []);
  if (!languageData) {
    return <div></div>;
  }
  const handleCreateAppointement = async () => {
    try {
      setLoading(true);
      const response = await api.post(
        `/services/appointments/add`,
        appointmentForm,
      );

      const appointment = response.data.data;
      const resp = { ok: true };
      if (!resp.ok) {
        throw new Error(resp.status);
      }
      const res = {
        status: "success",
        data: {},
      };
      setDataAppoint((prev) => ({
        ...prev,
        data: [...prev.data, appointment],
      }));
      Swal.fire({
        icon: "success",
        title: languageData?.alert?.appointment_confirmed,
      });

      handleModalClose();
    } catch (error) {
        Swal.fire({
        icon: "error",
        title:   error.response?.data?.details?.[0]?.message === "day must be a date greater or equal to the current date"
            ? languageData?.alert?.appointment_confirmed.invalid_date
            : error.message,
      });
    } finally {
      setLoading(false);
    }
  };
  const Control = (props) => (
    <components.Control
      {...props}
      innerProps={{
        ...props.innerProps,
        "data-interaction": "experts_list",
      }}
    />
  );

  return (
    <div>
      <div className="">
        <div className="col-xl-12 col-sm-12">
          <div className="card custom-card">
            <div className="card-header justify-content-between gap-2">
              <div>
                <ul
                  className="nav nav-tabs nav-tabs-header mb-0 gap-1"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      data-interaction="consultations_tab_button"
                      className={`nav-link ${
                        activeTab === "consultations" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("consultations")}
                    >
                      {languageData.consultations.title}
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      data-interaction="appointment_tab_button"
                      className={`nav-link ${
                        activeTab === "appointments" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("appointments")}
                    >
                      {languageData.appointments.title}
                    </button>
                  </li>
                </ul>
              </div>

              <div className="card-actions">
                <button
                  data-interaction={
                    activeTab === "consultations"
                      ? "start_new_consultation_button"
                      : "book_appointment_button"
                  }
                  onClick={() => {
                    if (activeTab === "consultations") {
                      navigate("/experts");
                    } else if (activeTab === "appointments") {
                      handleModalOpen();
                    }
                  }}
                  className="btn btn-primary"
                >
                  {activeTab === "consultations"
                    ? languageData.consultations.primary_btn
                    : languageData.appointments.primary_btn}
                </button>
              </div>
            </div>

            <div className="card-body">
              <div className="tab-content">
                {activeTab === "consultations" && <Consulthist />}
                {activeTab === "appointments" && (
                  <Appointments
                    dataAppoint={dataAppoint}
                    setDataAppoint={setDataAppoint}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title className="h6">
            {languageData.appointments.modal.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="expert" className="mb-3">
              <Form.Label>Expert</Form.Label>
              <Select
                components={{ Control }}
                options={expertOptions}
                isLoading={expertsLoading}
                placeholder={languageData.appointments.select_expert}
                noOptionsMessage={() =>
                  expertsLoading ? (
                    <LoadingSpinner />
                  ) : (
                    `${languageData.appointments.no_expert}`
                  )
                }
                loadingMessage={() => <LoadingSpinner />}
                value={expertOptions.find(
                  (option) => option.value === appointmentForm.expert_id,
                )}
                name="experts_list"
                onChange={(selectedOption) =>
                  setAppointmentForm((prev) => ({
                    ...prev,
                    expert_id: selectedOption.value,
                  }))
                }
                formatOptionLabel={(option) => (
                  <div className="flex align-items-center gap-8p">
                    {option.image ? (
                      <img
                        className="img_app"
                        src={option.image}
                        alt={option.label}
                      />
                    ) : (
                      <div className="label_exp" />
                    )}

                    <span>{option.label}</span>
                  </div>
                )}
              />
            </Form.Group>

            <div className="flex gap-20 mb-10 w-100">
              <Form.Group controlId="day" className="flex flex-column">
                <Form.Label>{languageData.appointments.modal.day}</Form.Label>

                <Flatpickr
                  className="form-control modal-datepicker"
                  options={{
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altFormat: "F j, Y",
                    position: "auto",
                    enableTime: false,
                    monthSelectorType: "dropdown",
                    yearSelector: true,
                    appendTo: document.body,
                    static: true,
                    onReady: (_, __, instance) => {
                      instance.altInput.setAttribute(
                        "data-interaction",
                        "date",
                      );
                      instance.altInput.setAttribute("name", "date");
                    },
                  }}
                  value={appointmentForm.day}
                  onChange={([selectedDate]) =>
                    handleChangeValue("day", formatDate(selectedDate))
                  }
                />
              </Form.Group>
              <Form.Group controlId="time" className="flex flex-column">
                <Form.Label>{languageData.appointments.modal.hour}</Form.Label>
                <Flatpickr
                  name="time"
                  className="form-control modal-datepicker"
                  data-enable-time
                  options={{
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: "H:i",
                    altInput: true,
                    altFormat: "H:i",
                    time_24hr: true,
                    position: "auto",
                    appendTo: document.body,
                    static: true,
                    onReady: (_, __, instance) => {
                      instance.altInput.setAttribute(
                        "data-interaction",
                        "time",
                      );
                      instance.altInput.setAttribute("name", "time");
                    },
                    onClose: () => {
                      document.activeElement.blur();
                    },
                  }}
                  value={appointmentForm.hour}
                  onChange={([date]) => {
                    if (!date) return;

                    const hours = String(date.getHours()).padStart(2, "0");
                    const minutes = String(date.getMinutes()).padStart(2, "0");

                    handleChangeValue("hour", `${hours}:${minutes}`);
                  }}
                />
              </Form.Group>
            </div>

            <Form.Group className="mb-3">
              <Form.Label>
                {languageData.appointments.modal.recalled_by}
              </Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  id="recall-phone"
                  type="radio"
                  label={languageData.appointments.modal.phone}
                  name="recalledBy"
                  value="phone"
                  checked={recalledBy === "Phone"}
                  onChange={() => handleRecallTypeChange("Phone")}
                />
                <Form.Check
                  id="recall-email"
                  type="radio"
                  label={languageData.appointments.modal.mail}
                  name="recalledBy"
                  value="email"
                  checked={recalledBy === "Email"}
                  onChange={() => handleRecallTypeChange("Email")}
                />
                <Form.Check
                  id="recall-sms"
                  type="radio"
                  value="sms"
                  label={languageData.appointments.modal.sms}
                  name="recalledBy"
                  checked={recalledBy === "SMS"}
                  onChange={() => handleRecallTypeChange("SMS")}
                />
              </div>
            </Form.Group>

            {recalledBy === "Phone" || recalledBy === "SMS" ? (
              <Form.Group controlId="phoneNumber" className="mb-3">
                <Form.Label>
                  {languageData.appointments.modal.phone_number}
                </Form.Label>
                <PhoneInput
                  name="phone"
                  defaultCountry={defaultCountry}
                  className="form-control p-0"
                  inputStyle={{
                    width: "100%",
                    border: "none",
                    backgroundColor: "transparent",
                    boxShadow: "none",
                  }}
                  value={appointmentForm.recall_element}
                  onChange={(value) =>
                    setAppointmentForm((prev) => ({
                      ...prev,
                      recall_element: value,
                    }))
                  }
                />
              </Form.Group>
            ) : recalledBy === "Email" ? (
              <Form.Group controlId="email" className="mb-3">
                <Form.Label>
                  {languageData.appointments.modal.email_address}
                </Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Email address"
                  value={appointmentForm.recall_element}
                  onChange={(e) =>
                    setAppointmentForm((prev) => ({
                      ...prev,
                      recall_element: e.target.value,
                    }))
                  }
                />
              </Form.Group>
            ) : null}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            data-interaction="close_modal_appointment"
            className="close_modal_btn"
            onClick={handleModalClose}
          >
            {languageData.appointments.modal.cancel}
          </Button>
          <Button
            variant="primary"
            onClick={() => handleCreateAppointement()}
            data-interaction="confirm_appointment_button"
          >
            {languageData.appointments.modal.save}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Spinner Overlay */}
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default Tab_content;
